import React from 'react'

const Error = () => {
  return (
    <div>404 Page Not Found</div>
  )
}

export default Error